<template>
  <div class="item-container" :class="{ 'is-active': isActive, 'is-small': isSmall }">
    <span class="label"
      :style="{ color: filterColor(weaponInfo.level), backgroundColor: hexToRgba(filterColor(weaponInfo.level), 0.2) }">
      <span>{{ weaponInfo.level }}</span>
    </span>
    <div class="weapon-preview">
      <div class="model-status" :style="{ borderColor: filterColor(weaponInfo.level) }"></div>
      <div class="weapon-img-wrap">
        <img :src="weaponInfo.image" alt="weapon" />
      </div>
    </div>
    <div class="weapon-name " :style="{ backgroundColor: isActive ? filterColor(weaponInfo.level) : '' }">
      <span class="sle">{{ weaponInfo.name }}</span>
    </div>
  </div>
</template>

<script>
import { weaponCasesDict } from "@/utils/dict";
export default {
  components: {},
  props: {
    category: String,
    isActive: Boolean,
    weaponInfo: {
      type: Object,
      default: () => { }
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  mounted() { },
  methods: {
    filterColor(value) {
      const info = weaponCasesDict.find(item => item.adminLabel === value);
      return info ? info.value : "";
    },
    hexToRgba(hex, opacity) {
      // 去除 # 号并将字符串分割成 R、G、B 的十六进制分量
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);

      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>